// extracted by mini-css-extract-plugin
export default {"background":"tasks_background__YBGOM"};